import LocationPageTemplate from '../LocationPageTemplate';
import { locationFaqs } from '../../../mocks/faqs';

export default function ClearwaterPage() {
  return (
    <LocationPageTemplate
      city="Clearwater"
      heroImage="https://www.parksidepavers.com/files/projects/15/images/thumb/thumb_large_Albano%2Dlanai%2Ejpg"
      description="Expert paver installation in Clearwater, FL — custom pool decks, driveways, patios, and outdoor living spaces for Clearwater Beach area homeowners."
      geoDescription="Parkside Pavers serves Clearwater and the surrounding Pinellas County area with professional hardscape solutions. Paver installation in Clearwater, patio design near Clearwater Beach, and custom driveway pavers throughout the area."
      mapEmbedSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56419.12345678!2d-82.8001!3d27.9659!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2f4a99999999%3A0x0!2sClearwater%2C%20FL!5e0!3m2!1sen!2sus!4v1699000000000!5m2!1sen!2sus"
      faqs={locationFaqs.clearwater}
    />
  );
}
